export const initialState = {
  values: []
};

export function reducer(state, action) {
  switch (action.type) {
    case 'OnInitState':
      return onInitState(state, action);
    case 'OnReportFilterAdded':
      return onReportFilterAdded(state, action);
    case 'OnReportFilterDeleted':
      return onReportFilterDeleted(state, action);
    case 'OnReportFilterPropertyChanged':
      return OnReportFilterPropertyChanged(state, action);
    case 'OnReportFilterExpanded':
      return onReportFilterExpanded(state, action);
    case 'OnReportFilterSaved':
      return onReportFilterSaved(state, action);
    case 'OnFilterDeleted':
      return onFilterDeleted(state, action);
    case 'OnFilterPropertyChanged':
      return onFilterPropertyChanged(state, action);
    default:
      return state;
  }
}

function onInitState(state, action) {
  const { data } = action;
  return {
    ...state,
    values: data.map(item => {
      return { ...item, changed: false, isExpanded: false };
    })
  };
}

function onReportFilterDeleted(state, action) {
  const { index } = action;
  const newFilters = Object.assign([...state.values]);
  newFilters.splice(index, 1);
  return {
    ...state,
    values: newFilters
  };
}

const onReportFilterExpanded = (state, action) => {
  const { index, isExpanded } = action;
  return {
    ...state,
    values: Object.assign([...state.values], {
      [index]: {
        ...state.values[index],
        isExpanded: isExpanded
      }
    })
  };
};

function onReportFilterAdded(state, action) {
  const reportFilter = {
    orderNo: '',
    reportId: action.reportId,
    filterCode: '',
    filterCaption: '',
    adaptiveDataSource: '',
    displayMember: '',
    allowNull: false,
    defaultValue: '',
    isExpanded: false
  };
  const newReportFilters = Object.assign([...state.values]);
  newReportFilters.push({ ...reportFilter, changed: true });
  return {
    ...state,
    values: newReportFilters
  };
}

function OnReportFilterPropertyChanged(state, action) {
  const { propertyName, value, index } = action;
  return {
    ...state,
    values: Object.assign([...state.values], {
      [index]: {
        ...state.values[index],
        [propertyName]: value,
        changed: true
      }
    })
  };
}

function onFilterDeleted(state, action) {
  const { index } = action;
  const newFilters = Object.assign([...state.values]);
  newFilters.splice(index, 1);
  return {
    ...state,
    values: newFilters
  };
}

function onFilterPropertyChanged(state, action) {
  const { filterPropertyName, filterPropertyValue, index } = action;
  return {
    ...state,
    values: Object.assign([...state.values], {
      [index]: {
        ...state.values[index],
        [filterPropertyName]: filterPropertyValue,
        changed: true
      }
    })
  };
}

function onReportFilterSaved(state, action) {
  const { index } = action;
  return {
    ...state,
    values: Object.assign([...state.values], {
      [index]: {
        ...state.values[index],
        changed: false
      }
    })
  };
}
